<template>
	<div>
		<b-breadcrumb>
			<b-breadcrumb-item to="/">{{$title}}</b-breadcrumb-item>
			<b-breadcrumb-item active>Chatters</b-breadcrumb-item>
		</b-breadcrumb>

		<b-alert show v-if="error" variant="danger">{{error&&(error.error||error.toString())}}</b-alert>
		<div v-else-if="total > 0">
			<b-input v-model="q" placeholder="Search..." @input="loadChatters()" class="mb-2"></b-input>
			<b-table small striped hover show-empty :items="chatters" :busy="loading>0" :fields="['chatter',{ key: 'tts_status', label: 'Mute TTS' },'voice','instrument',{ label: '', key: 'actions', thClass: 'text-right', tdClass: 'text-right'}]">
				<template #cell(chatter)="data">
					<b-avatar size="3em" :src="data.item.avatar_url" badge-variant=""  badge-offset="-0.4em">
						<template #badge><b-avatar :src="data.item.service_icon_url" size="1.3em" class="service_avatar" square :title="data.item.service_name"></b-avatar></template>
					</b-avatar>
					{{data.item.display_name||data.item.chatter_token}}
				</template>
				<template #cell(tts_status)="data">
					<b-form-checkbox switch v-model="data.item.tts_status" value="muted" unchecked-value="enabled" @change="setTtsStatus(data.item)" :disabled="data.item.changingStatus" :state="data.item.changingState"></b-form-checkbox>
				</template>
				<template #cell(voice)="data">
					{{data.item.voice_name||'-'}}<br />
					<small class="text-muted" v-if="data.item.settings?.pitch && !isNaN(parseFloat(data.item.settings.pitch)) && data.item.settings.pitch != 0.5">
						Pitch = {{(Math.round(parseFloat(data.item.settings.pitch||.5) * 100) / 100).toFixed(2)}}
					</small>
					<small class="text-muted" v-if="data.item.settings?.rate && !isNaN(parseFloat(data.item.settings.rate)) && data.item.settings.rate != 0.5">
						Rate = {{(Math.round(parseFloat(data.item.settings.rate||.5) * 100) / 100).toFixed(2)}}
					</small>
				</template>
				<template #cell(instrument)="data">
					{{data.item.settings&&data.item.settings.instrument||'-'}}
				</template>
				<template #cell(actions)="data">
					<b-button-group size="sm">
						<b-button @click="$refs.editModal.show(data.item.service_id, data.item.chatter_token)" v-b-tooltip.hover.left title="Edit chatter"><b-icon icon="pencil-fill"></b-icon></b-button>
					</b-button-group>
				</template>
				<template #empty>
					<div class="text-center">No results.</div>
				</template>
			</b-table>
			<pager :per-page="perPage" :skip="skip" :total="total" @change="setPage"></pager>
		</div>
		<b-card v-else class="text-center text-muted p-5">No chatters have been logged yet.<br />As people change their voice settings, they will appear here.</b-card>
		<chatter-edit-modal ref="editModal" @saved="loadChatters()"/>
	</div>
</template>

<script>
import debounce from 'debounce';
import Pager from '@/components/Pager.vue';
import ChatterEditModal from '@/components/Chatter/Modal/Edit.vue';

export default {
	name: 'Chatters',
	components: {
		Pager,
		ChatterEditModal,
	},
	data() { return {
		chatters: [],
		error: null,
		loading: 0,
		total: 0,
		skip: 0,
		perPage: 10,
		q: undefined,
	}},
	async mounted() {
		try {
			this.loading++;
			this.error = null;

			this.q = this.$route.query.q||'';
			this.skip = parseInt(this.$route.query.skip||0)||0;
			this.perPage = parseInt(this.$route.query.perPage||10)||10;

			this.giftTypes = [];
			await this.loadChatters();

			this.$watch('$route', $route => {
				this.skip = parseInt($route.query.skip||0)||0;
				this.perPage = parseInt($route.query.perPage||10)||10;
				this.reloadChatters();
			});
			this.$watch('q', debounce(q => this.$router.push({
				path: this.$route.path,
				query: {
					...this.$route.query,
					skip: undefined,
					q: q||undefined,
				},
			}), 300));
		} catch(e) {
			console.error(e);
			this.error = e;
		} finally {
			this.loading--;
		}
	},
	methods: {
		setPage($event) {
			this.$router.push({
				path: this.$route.path,
				query: {
					...this.$route.query,
					skip: $event.skip || undefined,
					perPage: $event.perPage == 10 ? undefined : $event.perPage,
				},
			});
		},
		async loadChatters() {
			const result = await this.$api.get('chatters', {
				q: this.$route.query.q||'',
				skip: this.skip,
				limit: this.perPage,
			});
			this.chatters = result.results;
			this.total = result.total;
		},
		async reloadChatters() {
			try {
				this.loading++;
				this.error = null;
				await this.loadChatters();
			} catch(e) {
				console.error(e);
				this.error = e;
			} finally {
				this.loading--;
			}
		},
		setTtsStatus(item) {
			this.$set(item, 'changingStatus', true);
			this.$set(item, 'changingState', undefined);
			this.loading++;
			this.error = null;
			this.$api.post(`/chatter/${encodeURIComponent(item.service_id)}/${encodeURIComponent(item.chatter_token)}/ttsStatus`, { tts_status: item.tts_status }).then(() => {
				this.$set(item, 'changingState', undefined);
				this.$bvToast.toast(`TTS ${item.tts_status}`, { title: 'Success', variant: 'success', solid: true });
			}, err => {
				this.$set(item, 'changingState', false);
				this.$bvToast.toast(err.message||err, { title: 'Could not change chatter TTS status', variant: 'danger', solid: true });
				console.error('Could not set chatter TTS status', item.name, status, err);
			}).finally(() => {
				this.$set(item, 'changingStatus', false);
				this.loading--;
			});
		},
	},
};
</script>
